/** Regular expressions */
export const regex = {
  /** Allow only numbers */
  ONLY_NUMBERS: /^[0-9]+$/,
};

/** HTTP request header */
export const HTTP_TOKEN_HEADER = 'x-access-token';
